import React, { useState } from 'react';
import { Form, Row, Col, Alert } from 'antd';
import { InputComponent, SelectComponent } from '@pfmam/pfmam';
import { CaretDownOutlined } from '@ant-design/icons';
export const AccountInformation = (props) => {
  const { form, accountOptions, paidDividendsChoice,
    setPaidDividendsChoice, setFormValues, accountTitleStatus,
    accountTitleMsg, validating } = props; // Destructure form from props

  const handleTrimField = (fieldName) => {
    const fieldValue = form.getFieldValue(fieldName);
    if (typeof fieldValue === 'string') {
      const trimmedValue = fieldValue.trim();
      if (fieldValue !== trimmedValue) {
        form.setFieldsValue({ [fieldName]: trimmedValue });
      }
    }
  };

  // Update state based on selection
  const handlePaidDividendsChange = (value) => {
    setFormValues((prevValues) => ({
      ...prevValues,
      additionalAccTitle: null,
      paidDividendsAccount: null, // Reset these fields when the choice changes
    }));
    setPaidDividendsChoice(value);
  };
  // Update Additional Account Title when accTitle or paidDividendsChoice changes
  const handleFormValuesChange = (changedValues, allValues) => {
    if (changedValues.paidDividendsAccountOptions === 'Yes') {
      const accTitle = allValues.accTitle;
      if (accTitle) {
        form.setFieldsValue({additionalAccTitle: `${accTitle}-Int`});
      }
    }
  };
  return (
    <>
      <Form onValuesChange={handleFormValuesChange} form={form} name="basic" layout="vertical" className="forms">
        {/* Show custom alert above Account Title */}
        {accountTitleStatus && (
          <Row>
            <Col span={24}>
              <Alert
                message={accountTitleMsg}
                type={accountTitleStatus}
                showIcon
                style={{ marginBottom: 10 }}
              />
            </Col>
          </Row>
        )}
        {/* First Row: Account Title */}
        <Row gutter={24} align="left">
          <Col span={10}>
            <Form.Item>
              <label>Account Title</label>
            </Form.Item>
          </Col>
          <Col span={14}>
            <Form.Item name="accTitle" rules={[
              {
                required: true,
                message: 'Account Title Required',
              },
              {
                max: 50,
                message: 'Account Title cannot exceed 50 characters',
              },
              {
                validator: (_, value) => {
                  if (value && value.trim().length === 0) {
                    return Promise.reject('Account Title cannot be only spaces');
                  }
                  // Allow only letters, numbers, spaces, and hyphens
                  if (!value || /^[a-zA-Z0-9 \-]+$/.test(value)) {
                    return Promise.resolve();
                  }
                  return Promise.reject('Account Title cannot contain special characters');
                }
              }
            ]}>
              <InputComponent
                maxLength={50}
                placeholder="Enter Account Title"
                data-name="accTitle"
                type="default"
                onBlur={() => handleTrimField('accTitle')}
                loading={validating ? 1 : 0} />
            </Form.Item>
          </Col>
        </Row>

        {/* Second Row: Bond Proceeds */}
        <Row gutter={24} align="left">
          <Col span={10}>
            <Form.Item>
              <label>Is this Account being set up for bond proceeds?</label>
            </Form.Item>
          </Col>
          <Col span={14}>
            <Form.Item name="isAccBonds" rules={[
              {
                required: true,
                message: 'Bond Proceeds Required',
              },
            ]}>
              <SelectComponent
                option={[
                  {
                    label: 'Yes',
                    value: 'Yes',
                  },
                  {
                    label: 'No',
                    value: 'No',
                  },
                ]}
                placeholder="Select Option"
                suffixIcon={<CaretDownOutlined />}
                dropdownClassName="form-select-dropdown"
                bordered={true}
              />
            </Form.Item>
          </Col>
        </Row>
        {/* Third Row: Bond Proceed Accounts */}
        <Row gutter={24} align="left">
          <Col span={10}>
            <Form.Item>
              <label>Do you want dividends to be deposited into a new, separate account? Selecting this option will create an additional unique account used only for dividend activity (commonly used for bond proceeds).</label>
            </Form.Item>
          </Col>
          <Col span={14}>
            <Form.Item name="paidDividendsAccountOptions" rules={[
              {
                required: true,
                message: 'Paid Dividends Account Options Required',
              },
            ]}>
              <SelectComponent
                option={[
                  {
                    label: 'Yes',
                    value: 'Yes',
                  },
                  {
                    label: 'No',
                    value: 'No',
                  },
                ]}
                placeholder="Select Option"
                suffixIcon={<CaretDownOutlined />}
                dropdownClassName="form-select-dropdown"
                onChange={handlePaidDividendsChange} // Handle selection change
                bordered={true}
              />
            </Form.Item>
          </Col>
        </Row>
        {/* Fourth Row:Additional Account Title */}
        {/* Conditional Rendering Based on paidDividendsAccount */}
        {paidDividendsChoice === 'Yes' && (
          <Row gutter={24} align="left">
            <Col span={10}>
              <Form.Item>
                <label>Please enter Account Name for new Additional Account:</label>
              </Form.Item>
            </Col>
            <Col span={14}>
              <Form.Item name="additionalAccTitle" rules={[
                {
                  required: paidDividendsChoice === 'Yes' ? true : false,
                  message: 'Account Title Required',
                },
                {
                  max: 50,
                  message: 'Account Title cannot exceed 50 characters',
                },
                {
                  validator: (_, value) => {
                    if (value && value.trim().length === 0) {
                      return Promise.reject('Account Title cannot be only spaces');
                    }
                    // Allow only letters, numbers, spaces, and hyphens
                    if (!value || /^[a-zA-Z0-9 \-]+$/.test(value)) {
                      return Promise.resolve();
                    }
                    return Promise.reject('Account Title cannot contain special characters');
                  }
                }
              ]}>
                <InputComponent
                  maxLength={50}
                  placeholder="Enter Additional Account Name"
                  data-name="additionalAccTitle"
                  type="default"
                  onBlur={() => handleTrimField('additionalAccTitle')} />
              </Form.Item>
            </Col>
          </Row>
        )}
        {/* Fifth Row: Pay Dividends */}
        {paidDividendsChoice === 'No' && (
          <Row gutter={24} align="left">
            <Col span={10}>
              <Form.Item>
                <label>Pay Dividends by reinvestment in:</label>
              </Form.Item>
            </Col>
            <Col span={14}>
              <Form.Item name="paidDividendsAccount" rules={[
                {
                  required: paidDividendsChoice === 'No' ? true : false,
                  message: 'Paid Dividends Account Required',
                },
              ]}>
                <SelectComponent
                  option={accountOptions} // Use mapped account options
                  placeholder="Select Account"
                  suffixIcon={<CaretDownOutlined />}
                  dropdownClassName="form-select-dropdown"
                  bordered={true}
                />
              </Form.Item>
            </Col>
          </Row>
        )}
      </Form>
    </>
  );
};